const templates = [
	{
		id: 'wishlist-link',
		data: 'wishlist',
		template: `
        <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}">
          <div class="wk-icon wk-link__icon">{% include "wishlist-icon" %}</div>
          <span class="wk-link__label">{{ locale.wishlist }}</span>
          <span class="wk-link__count">{{ wishlist.item_count }}</span>
        </a>
      `,
	},
	{
		id: 'wishlist-button',
		data: 'product',
		events: {
			'click button[data-wk-add-product]': (event) => {
				event.preventDefault()
				event.stopPropagation()

				const variantInput = document.querySelector("form *[name='id']")
				const variantId = variantInput ? variantInput.value : undefined

				WishlistKing.toolkit.addProduct(
					event.currentTarget.getAttribute('data-wk-add-product'),
					variantId
				)
			},
			'click button[data-wk-remove-product]': (event) => {
				event.preventDefault()
				event.stopPropagation()

				WishlistKing.toolkit.removeProduct(
					event.currentTarget.getAttribute('data-wk-remove-product')
				)
			},
			'click button[data-wk-remove-item]': (event) => {
				event.preventDefault()
				event.stopPropagation()

				WishlistKing.toolkit.removeItem(
					event.currentTarget.getAttribute('data-wk-remove-item')
				)
			},
		},
		template: `
        {% if product.in_wishlist %}
          {% assign btn_text = locale.in_wishlist %}
          {% assign btn_title = locale.remove_from_wishlist %}
          {% assign btn_action = 'remove' %}
        {% else %}
          {% assign btn_text = locale.add_to_wishlist %}
          {% assign btn_title = locale.add_to_wishlist %}
          {% assign btn_action = 'add' %}
        {% endif %}
        {% assign scope = "product" %}
        {% assign targetId = product.id %}
        {% assign icon_name = "wishlist-icon" %}
        {% if itemId %}
        {% assign scope = "item" %}
        {% assign targetId = itemId %}
        {% assign icon_name = "remove-icon" %}
        {% endif %}
        <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
          <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
          <span class="wk-button__label">{{ btn_text }}</span>
        </button>
      `,
	},
	{
		id: 'wishlist-button-floating',
		data: 'product',
		template: `
        {% include "wishlist-button" addClass: "wk-button--floating" %}
      `,
	},
	{
		id: 'cart-wishlist-button',
		data: 'product',
		events: {
			'click a[data-wk-add-product]': async (event) => {
				event.preventDefault()
				event.stopPropagation()

				const variantInput = document.querySelector("form *[name='id']")
				const variantId = variantInput ? variantInput.value : undefined

				WishlistKing.toolkit.addProduct(
					event.currentTarget.getAttribute('data-wk-add-product'),
					variantId
				)

				const cartItem = event.currentTarget.closest('.product-cart-item')
				const removeButton = cartItem.querySelector('.remove')
				removeButton.click()
			},
			'click a[data-wk-remove-product]': (event) => {
				event.preventDefault()
				event.stopPropagation()

				WishlistKing.toolkit.removeProduct(
					event.currentTarget.getAttribute('data-wk-remove-product')
				)
			},
			'click a[data-wk-remove-item]': (event) => {
				event.preventDefault()
				event.stopPropagation()

				WishlistKing.toolkit.removeItem(
					event.currentTarget.getAttribute('data-wk-remove-item')
				)
			},
		},
		template: `
        <div></div>
        {% if product.in_wishlist %}
          {% assign btn_text = locale.in_wishlist %}
          {% assign btn_title = locale.remove_from_wishlist %}
          {% assign btn_action = 'remove' %}
        {% else %}
          {% assign btn_text = locale.move_to_wishlist %}
          {% assign btn_title = locale.add_to_wishlist %}
          {% assign btn_action = 'add' %}
        {% endif %}
        {% assign scope = "product" %}
        {% assign targetId = product.id %}
        {% assign icon_name = "wishlist-icon" %}
        {% if itemId %}
        {% assign scope = "item" %}
        {% assign targetId = itemId %}
        {% assign icon_name = "remove-icon" %}
        {% endif %}
        <a type="button" {{ btn_href }} class="wk-button wk-button--{{ btn_action }} {{ index }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
          <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
          <span class="wk-button__label">{{ btn_text }}</span>
        </a>
      `,
	},
	{
		id: 'wishlist-page',
		data: 'wishlist',
		events: {
			'click a[data-wk-share]': (event) => {
				event.preventDefault()
				event.stopPropagation()

				WishlistKing.toolkit.requestWishlistSharing({
					wkShareService: event.currentTarget.getAttribute(
						'data-wk-share-service'
					),
					wkShare: event.currentTarget.getAttribute('data-wk-share'),
					wkShareImage: event.currentTarget.getAttribute('data-wk-share-image'),
				})
			},
		},
		template: `
        <div class='wk-page {% if wishlist.read_only %}wk-page--shared{% endif %}'>
        {% if wishlist.item_count == 0 %}
            <div class="wk-note wk-note__list-empty">
              <p>{{ locale.wishlist_empty_note }}</p>
            </div>
        {% else %}
          {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
            <div class="wk-note wk-note__login">
              <p>{{ locale.login_or_signup_note }}</p>
            </div>
          {% endif %}
          <div>
            <div class="wk-grid">
              {% assign item_count = 0 %}
              {% assign products = wishlist.products | reverse %}
              {% for product in products %}
                {% assign item_count = item_count | plus: 1 %}
                {% unless limit and item_count > limit %}
                  {% assign hide_default_title = false %}
                  {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                    {% assign hide_default_title = true %}
                  {% endif %}
                  {% assign variant = product.selected_or_first_available_variant %}
                  {% if variant.price < variant.compare_at_price %}
                    {% assign onsale = true %}
                  {% else %}
                    {% assign onsale = false %}
                  {% endif %}
                  <div>
                    <div class="wk-grid__item {% if onsale %}wk-product--sale{% endif %}" data-wk-item="{{ product.wishlist_item_id }}">
                      {% unless wishlist.read_only %}
                        {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                      {% else %}
                        {% include "wishlist-button-floating" product: product %}
                      {% endunless %}
                      <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '1000x' }})"></a>
                      <div class="wk-product-info">
                        <a class="wk-product-title" href="{{ product | variant_url }}">
                          {{ product.title }}
                        </a>
                        <div class="wk-product-price">
                          <span class="wk-product-price--compare">{{ variant.compare_at_price | money }}</span>
                          <span class="wk-product-price--current">{{ variant.price | money }}</span>
                          {% unless iso_code_country == 'US' %}
                            <span>{{ iso_code_currency }}</span>
                          {% endunless %}
                        </div>
                      </div>
					  {% unless product.tags contains 'hide-from-atc' %}
                      {% include "wishlist-product-form" %}
					  {% endunless %}
                    </div>
                  </div>
                {% endunless %}
              {% endfor %}
            </div>
          </div>
          {% comment %}
          {% include "wishlist-button-bulk-add-to-cart" %}
          {% endcomment %}
          {% comment %}
          {% unless wishlist.read_only %}
            {% include "wishlist-button-clear" %}
          {% endunless %}
          {% endcomment %}
          {% unless wishlist.read_only %}
            <div class="wk-sharing">
              <h4 class="wk-title">{{ locale.share_wishlist }}</h4>
              <ul class="wk-sharing__list">
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-fb" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-twitter" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-email" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-link" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-whatsapp" %}</li>
                {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
              </ul>
              <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
            </div>
          {% endunless %}
        {% endif %}
        </div>
      `,
	},
	{
		id: 'wishlist-product-form',
		events: {
			'render .wk-product-form': (form) => {
				const container = form.closest('[data-wk-item]')
				const itemId = container.getAttribute('data-wk-item')
				WishlistKing.toolkit.getItem(itemId).then((product) => {
					WishlistKing.toolkit.initProductForm(form, product, {
						// NOTE: Uncomment to override default option change
						// onOptionChange: (event) => {
						//   console.log(event.dataset);
						// },
						// NOTE: Uncomment to override default form submit
						onFormSubmit: (event) => {
							event.preventDefault()
							event.stopPropagation()

							function getSectionsToRender() {
								return [
									{
										id: 'Cart',
										section: 'main-cart',
										selector: '.thb-cart-form',
									},
									{
										id: 'Cart-Drawer',
										section: 'cart-drawer',
										selector: '.cart-drawer',
									},
									{
										id: 'cart-drawer-toggle',
										section: 'cart-bubble',
										selector: '.thb-item-count',
									},
								]
							}

							function onSubmitHandler() {
								const config = {
									method: 'POST',
									headers: {
										'X-Requested-With': 'XMLHttpRequest',
										Accept: 'application/javascript',
									},
								}
								let formData = new FormData(form)

								formData.append(
									'sections',
									getSectionsToRender().map((section) => section.section)
								)
								formData.append('sections_url', window.location.pathname)
								config.body = formData

								fetch(`${theme.routes.cart_add_url}`, config)
									.then((response) => response.json())
									.then((response) => {
										if (response.status) {
											console.error(response.description)
											return
										}

										renderContents(response)

										dispatchCustomEvent('cart:item-added', {
											product: response.hasOwnProperty('items')
												? response.items[0]
												: response,
										})
									})
									.catch((e) => {
										console.error(e)
									})
							}

							function renderContents(parsedState) {
								getSectionsToRender().forEach((section) => {
									if (!document.getElementById(section.id)) {
										return
									}
									const elementToReplace =
										document
											.getElementById(section.id)
											.querySelector(section.selector) ||
										document.getElementById(section.id)
									elementToReplace.innerHTML = getSectionInnerHTML(
										parsedState.sections[section.section],
										section.selector
									)

									if (typeof CartDrawer !== 'undefined') {
										new CartDrawer()
									}
									if (typeof Cart !== 'undefined') {
										new Cart().renderContents(parsedState)
									}
								})

								if (document.getElementById('Cart-Drawer')) {
									document.getElementById('Cart-Drawer').classList.add('active')
									document.body.classList.add('open-cart')
									document.body.classList.add('open-cc')
									document
										.getElementById('Cart-Drawer')
										.querySelector('.product-recommendations--full')
										.classList.add('active')
									dispatchCustomEvent('cart-drawer:open')
								}
							}

							function getSectionInnerHTML(
								html,
								selector = '.shopify-section'
							) {
								return new DOMParser()
									.parseFromString(html, 'text/html')
									.querySelector(selector).innerHTML
							}

							onSubmitHandler()
						},
					})
				})
			},
		},
		template: `
        <form class="wk-product-form" action="/cart/add" method="post">
          {% assign current_variant = product.selected_or_first_available_variant %}
          <div class="wk-product-form__options">
            <input name="id" value="{{ current_variant.id }}" type="hidden">
            {% unless product.has_only_default_variant %}
              {% for option in product.options_with_values %}
                <div class="wk-product-form__option">
                  <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                    {{ option.name }}
                  </label>
                  <select class="wk-product-form__option__select" name="options[{{ option.name | escape }}]">
                    {% for value in option.values %}
                      <option value="{{ value | escape }}" {% if option.selected_value == value %}selected="selected"{% endif %} {% if option.soldout_values contains value %}disabled{% endif %}>
                        {{ value }}
                      </option>
                    {% endfor %}
                  </select>
                </div>
              {% endfor %}
            {% endunless %}
            {% comment %}
            <div class="wk-product-form__quantity">
              <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
              <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
            </div>
            {% endcomment %}
          </div>
          <button type="submit" class="wk-product-form__submit single-add-to-cart-button button" data-wk-add-to-cart="{{ product.wishlist_item_id }}" {% unless current_variant.available %}disabled{% endunless %}>
            <span class="single-add-to-cart-button--text">{% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}</span>
          </button>
        </form>
      `,
	},
	{
		id: 'wishlist-page-shared',
		data: 'shared_wishlist',
		template: `
        {% assign wishlist = shared_wishlist %}
        {% include "wishlist-page" with wishlist %}
      `,
	},
	{
		id: 'wishlist-button-bulk-add-to-cart',
		data: 'wishlist',
		events: {
			'click button[data-wk-bulk-add-to-cart]': (event) => {
				WishlistKing.toolkit.requestAddAllToCart(
					event.currentTarget.getAttribute('data-wk-bulk-add-to-cart')
				)
			},
		},
		template: `
        {% assign btn_text = locale.add_all_to_cart %}
        {% assign btn_title = locale.add_all_to_cart %}
        <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
          <span class="wk-label">{{ btn_text }}</span>
        </button>
      `,
	},
	{
		id: 'wishlist-button-clear',
		data: 'wishlist',
		events: {
			'click button[data-wk-clear-wishlist]': (event) => {
				WishlistKing.toolkit.clear(
					event.currentTarget.getAttribute('data-wk-clear-wishlist')
				)
			},
		},
		template: `
        {% assign btn_text = locale.clear_wishlist %}
        {% assign btn_title = locale.clear_wishlist %}
        <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
          <span class="wk-label">{{ btn_text }}</span>
        </button>
      `,
	},
	{
		id: 'wishlist-icon',
		template: `
      <svg width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="path-one" fill-rule="evenodd" clip-rule="evenodd" d="M17.0002 29.8819L15.653 28.7031C12.7677 26.0312 10.3821 23.7438 8.49599 21.8408C6.88691 20.241 5.38225 18.5394 3.99128 16.7467C3.02247 15.5241 2.23418 14.1686 1.65052 12.722C1.23144 11.5837 1.0121 10.3816 1.00218 9.16873C0.977028 8.09285 1.16969 7.023 1.56858 6.02349C1.96747 5.02398 2.56436 4.11545 3.32336 3.35253C4.08235 2.5896 4.98779 1.98802 5.98522 1.58397C6.98266 1.17992 8.0515 0.981731 9.12749 1.00132C10.6612 0.992548 12.1686 1.39995 13.489 2.18012C14.9064 3.04926 16.1072 4.22986 17.0002 5.63233C17.95 4.21889 19.1936 3.02701 20.6461 2.13802C21.9224 1.38923 23.3763 0.996672 24.8561 1.00132C25.9328 0.981809 27.0024 1.17992 28.0007 1.58379C28.9991 1.98765 29.9056 2.58895 30.6659 3.35163C31.4262 4.11431 32.0247 5.02267 32.4255 6.02225C32.8263 7.02183 33.021 8.09204 32.9982 9.16873C32.9937 10.3993 32.7714 11.6194 32.3414 12.7725C31.7587 14.2023 30.9732 15.5407 30.0091 16.7467C28.6181 18.5394 27.1135 20.241 25.5044 21.8408C23.6295 23.7494 21.2439 26.0368 18.3474 28.7031L17.0002 29.8819ZM17.0002 27.3559C19.8069 24.8019 22.1139 22.6127 23.9214 20.7883C25.4499 19.2781 26.884 17.6753 28.2156 15.9889C29.1266 14.8733 29.8854 13.6416 30.4722 12.3262C30.8991 11.3132 31.1223 10.2259 31.129 9.12663C31.1544 8.30507 31.012 7.48696 30.7105 6.72229C30.4091 5.95762 29.9548 5.26245 29.3756 4.67928C28.7964 4.09611 28.1043 3.63717 27.3417 3.33053C26.5791 3.02388 25.762 2.87597 24.9403 2.89582C23.5128 2.88663 22.1199 3.33518 20.966 4.17566C19.6482 5.19299 18.5799 6.4975 17.8422 7.98993H16.2424C15.4884 6.50543 14.4091 5.21025 13.0849 4.20092C11.9401 3.35219 10.5525 2.89458 9.12749 2.89582C8.30896 2.87304 7.49445 3.01818 6.73418 3.32229C5.97391 3.6264 5.28399 4.08303 4.70698 4.66402C4.11277 5.25084 3.64546 5.95349 3.33405 6.72839C3.02265 7.50329 2.87378 8.33391 2.89668 9.16873C2.9021 10.2521 3.11652 11.3242 3.52818 12.3262C4.11154 13.6431 4.86142 14.8797 5.75948 16.0058C7.08689 17.7059 8.53014 19.3124 10.0789 20.8136C11.9201 22.6267 14.2272 24.8075 17.0002 27.3559Z"/>
      <path class="path-two" d="M10.5 1.99994C13.3 1.99994 15.6667 4.99994 16.5 6.49994C17.1667 5.66661 19.2 3.69994 22 2.49994C25.5 0.999943 27 2.49994 29.5 3.49994C32 4.49994 32 7.99994 32.5 9.99994C32.9 11.5999 29.3333 15.9999 27.5 17.9999L17 28.9999L5.00001 16.9999C2.50001 14.4999 1.14441e-05 7.99994 2.50001 5.49994C5.00001 2.99994 7.00001 1.99994 10.5 1.99994Z" />
      <path class="path-three" d="M17.0002 29.8819L16.6709 30.2582L17.0002 30.5463L17.3294 30.2582L17.0002 29.8819ZM15.653 28.7031L15.3131 29.0701L15.3237 29.0794L15.653 28.7031ZM8.49599 21.8408L8.85112 21.4888L8.84852 21.4863L8.49599 21.8408ZM3.99128 16.7467L4.38634 16.4402L4.38317 16.4362L3.99128 16.7467ZM1.65052 12.722L1.18131 12.8947L1.18396 12.9019L1.18684 12.909L1.65052 12.722ZM1.00218 9.16873L1.50222 9.16464L1.50204 9.15704L1.00218 9.16873ZM3.32336 3.35253L2.96889 2.99989V2.99989L3.32336 3.35253ZM9.12749 1.00132L9.11838 1.50138L9.13035 1.50131L9.12749 1.00132ZM13.489 2.18012L13.7505 1.75382L13.7434 1.74964L13.489 2.18012ZM17.0002 5.63233L16.5784 5.90088L16.9889 6.54554L17.4152 5.9112L17.0002 5.63233ZM20.6461 2.13802L20.393 1.70669L20.385 1.71156L20.6461 2.13802ZM24.8561 1.00132L24.8545 1.50143L24.8651 1.50124L24.8561 1.00132ZM28.0007 1.58379L28.1883 1.12028V1.12028L28.0007 1.58379ZM32.9982 9.16873L32.4982 9.15812L32.4982 9.16691L32.9982 9.16873ZM32.3414 12.7725L32.8045 12.9612L32.8073 12.9542L32.8099 12.9472L32.3414 12.7725ZM30.0091 16.7467L29.6185 16.4345L29.6141 16.4402L30.0091 16.7467ZM25.5044 21.8408L25.1518 21.4862L25.1477 21.4904L25.5044 21.8408ZM18.3474 28.7031L18.6767 29.0795L18.686 29.071L18.3474 28.7031ZM17.0002 27.3559L16.6619 27.7241L16.9985 28.0335L17.3367 27.7257L17.0002 27.3559ZM23.9214 20.7883L23.57 20.4326L23.5662 20.4364L23.9214 20.7883ZM28.2156 15.9889L27.8283 15.6727L27.8232 15.6791L28.2156 15.9889ZM30.4722 12.3262L30.9289 12.53L30.933 12.5204L30.4722 12.3262ZM31.129 9.12663L30.629 9.11116L30.629 9.1236L31.129 9.12663ZM27.3417 3.33053L27.5282 2.86663V2.86663L27.3417 3.33053ZM24.9403 2.89582L24.937 3.39581L24.9447 3.39586L24.9523 3.39568L24.9403 2.89582ZM20.966 4.17566L20.6715 3.77136L20.6605 3.77988L20.966 4.17566ZM17.8422 7.98993V8.48993H18.1528L18.2904 8.21148L17.8422 7.98993ZM16.2424 7.98993L15.7966 8.21635L15.9355 8.48993H16.2424V7.98993ZM13.0849 4.20092L13.388 3.80323L13.3827 3.79928L13.0849 4.20092ZM9.12749 2.89582L9.11357 3.39563L9.12075 3.39583L9.12792 3.39582L9.12749 2.89582ZM6.73418 3.32229L6.54848 2.85805V2.85805L6.73418 3.32229ZM4.70698 4.66402L5.05833 5.0198L5.06175 5.01636L4.70698 4.66402ZM2.89668 9.16873L3.3968 9.16623L3.39649 9.15501L2.89668 9.16873ZM3.52818 12.3262L3.06552 12.5163L3.07103 12.5287L3.52818 12.3262ZM5.75948 16.0058L6.15361 15.6981L6.15039 15.694L5.75948 16.0058ZM10.0789 20.8136L10.4298 20.4573L10.4269 20.4546L10.0789 20.8136ZM16.5 6.49994L16.0629 6.74276L16.4249 7.39426L16.8904 6.81229L16.5 6.49994ZM5.00001 16.9999L5.35357 16.6464L5.35356 16.6464L5.00001 16.9999ZM17 28.9999L16.6464 29.3535L17.0083 29.7154L17.3617 29.3452L17 28.9999ZM27.5 17.9999L27.8618 18.3453L27.8686 18.3378L27.5 17.9999ZM32.5 9.99994L32.9851 9.87868V9.87867L32.5 9.99994ZM29.5 3.49994L29.6857 3.0357L29.5 3.49994ZM22 2.49994L21.803 2.04037V2.04037L22 2.49994ZM17.3294 29.5056L15.9822 28.3268L15.3237 29.0794L16.6709 30.2582L17.3294 29.5056ZM15.9927 28.3363C13.1105 25.6672 10.7304 23.385 8.85111 21.4889L8.14086 22.1928C10.0337 24.1025 12.4249 26.3952 15.3133 29.07L15.9927 28.3363ZM8.84852 21.4863C7.25463 19.9015 5.76416 18.216 4.38632 16.4402L3.59625 17.0532C5.00033 18.8629 6.5192 20.5805 8.14345 22.1954L8.84852 21.4863ZM4.38317 16.4362C3.44407 15.251 2.67996 13.9372 2.11421 12.5349L1.18684 12.909C1.78839 14.4001 2.60086 15.7971 3.59939 17.0573L4.38317 16.4362ZM2.11973 12.5492C1.72054 11.465 1.51161 10.32 1.50216 9.16464L0.502197 9.17282C0.512588 10.4433 0.742336 11.7024 1.18131 12.8947L2.11973 12.5492ZM1.50204 9.15704C1.47847 8.14856 1.65906 7.14572 2.03297 6.20882L1.1042 5.83816C0.680318 6.90028 0.475589 8.03715 0.502317 9.18041L1.50204 9.15704ZM2.03297 6.20882C2.40687 5.27192 2.96637 4.4203 3.67782 3.70516L2.96889 2.99989C2.16235 3.81061 1.52808 4.77604 1.1042 5.83816L2.03297 6.20882ZM3.67782 3.70516C4.38928 2.99002 5.23799 2.42613 6.17295 2.04739L5.79749 1.12055C4.73758 1.54991 3.77543 2.18917 2.96889 2.99989L3.67782 3.70516ZM6.17295 2.04739C7.1079 1.66865 8.10979 1.48288 9.11838 1.50124L9.13659 0.501406C7.9932 0.480586 6.85741 0.691188 5.79749 1.12055L6.17295 2.04739ZM9.13035 1.50131C10.5736 1.49306 11.9921 1.87643 13.2347 2.6106L13.7434 1.74964C12.345 0.92346 10.7488 0.492039 9.12462 0.501331L9.13035 1.50131ZM13.2277 2.60637C14.5803 3.4358 15.7262 4.56248 16.5784 5.90088L17.4219 5.36377C16.4882 3.89725 15.2325 2.66272 13.7504 1.75388L13.2277 2.60637ZM17.4152 5.9112C18.3249 4.55747 19.516 3.41593 20.9071 2.56448L20.385 1.71156C18.8712 2.6381 17.5751 3.88032 16.5852 5.35345L17.4152 5.9112ZM20.8991 2.56928C22.0982 1.86577 23.4642 1.49695 24.8545 1.50132L24.8576 0.501326C23.2884 0.496394 21.7466 0.912684 20.393 1.70676L20.8991 2.56928ZM24.8651 1.50124C25.8746 1.48295 26.8773 1.66868 27.8132 2.0473L28.1883 1.12028C27.1275 0.691169 25.9911 0.480672 24.847 0.501405L24.8651 1.50124ZM27.8132 2.0473C28.7492 2.42592 29.599 2.98963 30.3118 3.70464L31.02 2.99863C30.2122 2.18827 29.249 1.54939 28.1883 1.12028L27.8132 2.0473ZM30.3118 3.70464C31.0246 4.41964 31.5857 5.27122 31.9614 6.20832L32.8896 5.83618C32.4637 4.77412 31.8279 3.80898 31.02 2.99863L30.3118 3.70464ZM31.9614 6.20832C32.3371 7.14542 32.5197 8.14873 32.4983 9.15812L33.4981 9.17933C33.5224 8.03535 33.3154 6.89824 32.8896 5.83618L31.9614 6.20832ZM32.4982 9.16691C32.4939 10.3385 32.2823 11.5 31.8729 12.5978L32.8099 12.9472C33.2605 11.7388 33.4935 10.4602 33.4982 9.17055L32.4982 9.16691ZM31.8784 12.5838C31.3138 13.9691 30.5527 15.266 29.6186 16.4345L30.3996 17.0589C31.3937 15.8155 32.2036 14.4354 32.8045 12.9612L31.8784 12.5838ZM29.6141 16.4402C28.2362 18.216 26.7458 19.9015 25.1519 21.4863L25.8569 22.1954C27.4812 20.5805 29 18.8629 30.4041 17.0532L29.6141 16.4402ZM25.1477 21.4904C23.2808 23.3909 20.9017 25.6722 18.0088 28.3353L18.686 29.071C21.5861 26.4014 23.9783 24.1078 25.8611 22.1912L25.1477 21.4904ZM18.0181 28.3268L16.6709 29.5056L17.3294 30.2582L18.6766 29.0794L18.0181 28.3268ZM17.3367 27.7257C20.1471 25.1683 22.4609 22.9728 24.2766 21.1402L23.5662 20.4364C21.7669 22.2525 19.4667 24.4354 16.6637 26.9861L17.3367 27.7257ZM24.2729 21.144C25.8159 19.6194 27.2637 18.0012 28.608 16.2988L27.8232 15.6791C26.5043 17.3493 25.0839 18.9368 23.57 20.4327L24.2729 21.144ZM28.6029 16.3052C29.5419 15.1552 30.324 13.8857 30.9288 12.5299L30.0156 12.1225C29.4468 13.3975 28.7113 14.5913 27.8283 15.6727L28.6029 16.3052ZM30.933 12.5204C31.3854 11.4468 31.6219 10.2946 31.629 9.12966L30.629 9.1236C30.6227 10.1572 30.4129 11.1795 30.0114 12.1321L30.933 12.5204ZM31.6287 9.14209C31.6562 8.25259 31.5021 7.36681 31.1757 6.5389L30.2454 6.90567C30.5219 7.6071 30.6525 8.35755 30.6292 9.11116L31.6287 9.14209ZM31.1757 6.5389C30.8493 5.71099 30.3575 4.95833 29.7304 4.32693L29.0209 5.03163C29.5522 5.56657 29.9689 6.20425 30.2454 6.90567L31.1757 6.5389ZM29.7304 4.32693C29.1032 3.69552 28.3539 3.19863 27.5282 2.86663L27.1552 3.79443C27.8547 4.07571 28.4895 4.49669 29.0209 5.03163L29.7304 4.32693ZM27.5282 2.86663C26.7026 2.53462 25.8178 2.37447 24.9282 2.39597L24.9523 3.39568C25.7061 3.37747 26.4556 3.51315 27.1552 3.79443L27.5282 2.86663ZM24.9435 2.39583C23.4091 2.38595 21.9119 2.86809 20.6716 3.77151L21.2604 4.57982C22.3279 3.80227 23.6164 3.38731 24.937 3.39581L24.9435 2.39583ZM20.6605 3.77988C19.2825 4.84368 18.1653 6.20777 17.394 7.76838L18.2904 8.21148C18.9944 6.78722 20.014 5.5423 21.2716 4.57145L20.6605 3.77988ZM17.8422 7.48993H16.2424V8.48993H17.8422V7.48993ZM16.6882 7.7635C15.9001 6.21192 14.772 4.85821 13.388 3.80327L12.7818 4.59858C14.0461 5.56229 15.0767 6.79894 15.7966 8.21635L16.6882 7.7635ZM13.3827 3.79928C12.1517 2.88658 10.6595 2.39449 9.12705 2.39582L9.12792 3.39582C10.4456 3.39468 11.7286 3.8178 12.7871 4.60257L13.3827 3.79928ZM9.1414 2.39602C8.25461 2.37133 7.37217 2.52858 6.54848 2.85805L6.91988 3.78653C7.61674 3.50778 8.36332 3.37475 9.11357 3.39563L9.1414 2.39602ZM6.54848 2.85805C5.7248 3.18752 4.97735 3.68224 4.35221 4.31169L5.06175 5.01636C5.59064 4.48382 6.22301 4.06527 6.91988 3.78653L6.54848 2.85805ZM4.35565 4.30826C3.7127 4.94321 3.20707 5.70349 2.87012 6.54195L3.79799 6.91483C4.08386 6.20349 4.51284 5.55847 5.05831 5.01979L4.35565 4.30826ZM2.87012 6.54195C2.53317 7.3804 2.37209 8.27915 2.39687 9.18244L3.39649 9.15501C3.37547 8.38867 3.51213 7.62617 3.79799 6.91483L2.87012 6.54195ZM2.39669 9.17123C2.40242 10.3189 2.62958 11.4546 3.06569 12.5162L3.99068 12.1362C3.60346 11.1937 3.40177 10.1852 3.39668 9.16623L2.39669 9.17123ZM3.07103 12.5287C3.6717 13.8847 4.44385 15.1581 5.36858 16.3175L6.15039 15.694C5.27899 14.6014 4.55137 13.4015 3.98534 12.1237L3.07103 12.5287ZM5.36538 16.3135C6.70695 18.0318 8.16561 19.6553 9.73095 21.1726L10.4269 20.4546C8.89467 18.9694 7.46683 17.3801 6.15359 15.6981L5.36538 16.3135ZM9.72812 21.1699C11.5748 22.9884 13.8864 25.1733 16.6619 27.7241L17.3385 26.9878C14.568 24.4416 12.2655 22.265 10.4298 20.4573L9.72812 21.1699ZM16.9371 6.25712C16.4977 5.46617 15.6645 4.29518 14.5713 3.31513C13.4844 2.34088 12.0775 1.49994 10.5 1.49994V2.49994C11.7225 2.49994 12.8989 3.15901 13.9038 4.05975C14.9021 4.95471 15.669 6.03372 16.0629 6.74276L16.9371 6.25712ZM10.5 1.49994C8.70015 1.49994 7.25099 1.75746 5.91983 2.35648C4.59286 2.95362 3.41841 3.87444 2.14646 5.14639L2.85356 5.8535C4.08161 4.62545 5.15716 3.79627 6.33019 3.2684C7.49903 2.74243 8.79987 2.49994 10.5 2.49994V1.49994ZM2.14646 5.14639C1.41088 5.88196 1.06993 6.88551 0.985905 7.961C0.901887 9.03644 1.0706 10.2222 1.39325 11.3838C2.03594 13.6974 3.32269 16.0297 4.64646 17.3535L5.35356 16.6464C4.17733 15.4702 2.96408 13.3024 2.35677 11.1161C2.05443 10.0277 1.91064 8.96345 1.98287 8.03889C2.05509 7.11438 2.33914 6.36792 2.85356 5.8535L2.14646 5.14639ZM4.64646 17.3535L16.6464 29.3535L17.3536 28.6464L5.35357 16.6464L4.64646 17.3535ZM17.3617 29.3452L27.8617 18.3452L27.1383 17.6547L16.6383 28.6547L17.3617 29.3452ZM27.8686 18.3378C28.7955 17.3266 30.1613 15.7084 31.2489 14.1341C31.7918 13.3483 32.2757 12.5587 32.5998 11.8522C32.7619 11.4988 32.8898 11.1537 32.9628 10.8315C33.0348 10.5141 33.0614 10.184 32.9851 9.87868L32.0149 10.1212C32.0386 10.2159 32.0413 10.3733 31.9876 10.6106C31.9349 10.843 31.8355 11.1198 31.6908 11.4352C31.4014 12.0662 30.954 12.8016 30.4261 13.5657C29.3721 15.0915 28.0378 16.6733 27.1314 17.6621L27.8686 18.3378ZM32.9851 9.87867C32.8658 9.40141 32.7763 8.83458 32.6644 8.195C32.5546 7.56783 32.4255 6.88664 32.2289 6.23127C31.8381 4.92871 31.148 3.62063 29.6857 3.0357L29.3143 3.96418C30.352 4.37926 30.9119 5.32117 31.2711 6.51862C31.4495 7.11325 31.5704 7.74455 31.6794 8.36738C31.7862 8.97781 31.8842 9.59847 32.0149 10.1212L32.9851 9.87867ZM29.6857 3.0357C29.0791 2.79306 28.5386 2.52252 27.9788 2.25862C27.428 1.99894 26.8646 1.74897 26.2588 1.58068C25.0147 1.23511 23.6481 1.24962 21.803 2.04037L22.197 2.95952C23.8519 2.25027 24.9853 2.26478 25.9912 2.5442C26.5104 2.68842 27.0095 2.90719 27.5524 3.16314C28.0864 3.41486 28.6709 3.70683 29.3143 3.96418L29.6857 3.0357ZM21.803 2.04037C18.9156 3.27783 16.819 5.30083 16.1096 6.1876L16.8904 6.81229C17.5144 6.03239 19.4844 4.12206 22.197 2.95952L21.803 2.04037Z"/>
      </svg>
    `,
	},
	{
		id: 'remove-icon',
		template: `
        <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <path vector-effect="non-scaling-stroke" d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"/>
          <path vector-effect="non-scaling-stroke" d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"/>
        </svg>
      `,
	},
	{
		id: 'wishlist-share-button-fb',
		data: 'wishlist',
		template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
          <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
            <path fill="currentColor" d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/>
          </svg>
        </a>
      `,
	},
	{
		id: 'wishlist-share-button-twitter',
		data: 'wishlist',
		template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
          <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/>
          </svg>
        </a>
      `,
	},
	{
		id: 'wishlist-share-button-whatsapp',
		data: 'wishlist',
		template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
          <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
            <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
          </svg>
        </a>
      `,
	},
	{
		id: 'wishlist-share-button-email',
		data: 'wishlist',
		template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
          <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24"">
            <path fill="currentColor" d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/>
          </svg>
        </a>
      `,
	},
	{
		id: 'wishlist-share-button-link',
		data: 'wishlist',
		template: `
        <a href="#" class="wk-share-button" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
          <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 512 512'>
            <path fill="currentColor" d='M459.654,233.373l-90.531,90.5c-49.969,50-131.031,50-181,0c-7.875-7.844-14.031-16.688-19.438-25.813
              l42.063-42.063c2-2.016,4.469-3.172,6.828-4.531c2.906,9.938,7.984,19.344,15.797,27.156c24.953,24.969,65.563,24.938,90.5,0
              l90.5-90.5c24.969-24.969,24.969-65.563,0-90.516c-24.938-24.953-65.531-24.953-90.5,0l-32.188,32.219
              c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984,131.031-49.984,181.031,0
              C509.623,102.342,509.623,183.389,459.654,233.373z M220.326,382.186l-32.203,32.219c-24.953,24.938-65.563,24.938-90.516,0
              c-24.953-24.969-24.953-65.563,0-90.531l90.516-90.5c24.969-24.969,65.547-24.969,90.5,0c7.797,7.797,12.875,17.203,15.813,27.125
              c2.375-1.375,4.813-2.5,6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828c-49.969-49.984-131.031-49.984-181.016,0
              l-90.5,90.5c-49.984,50-49.984,131.031,0,181.031c49.984,49.969,131.031,49.969,181.016,0l68.594-68.594
              C274.561,395.092,246.42,392.342,220.326,382.186z'/>
          </svg>
        </a>
      `,
	},
	{
		id: 'wishlist-share-button-contact',
		data: 'wishlist',
		template: `
        <a href="#" class="wk-share-button" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
          <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
          </svg>
        </a>
      `,
	},
]

export default templates
